
import React from "react";

function getPageItems(
  currentPage,
  totalItems,
  pageSize,
  maxButtons = 7
) {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  if (totalPages <= maxButtons) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }

  const items = [];
  const left = Math.max(1, currentPage - 2);
  const right = Math.min(totalPages, currentPage + 2);

  // Always show first page
  items.push(1);

  // Left ellipsis
  if (left > 2) items.push("…");

  // Middle window
  for (let p = left; p <= right; p++) {
    if (p !== 1 && p !== totalPages) items.push(p);
  }

  // Right ellipsis
  if (right < totalPages - 1) items.push("…");

  // Always show last page
  if (totalPages > 1) items.push(totalPages);

  // If too many items due to edges, reduce to maxButtons by trimming middle (rare)
  const numericCount = items.filter(i => i !== "…").length;
  if (items.length > maxButtons + (items.length - numericCount)) {
    // Optional: implement smarter trimming if you want strict cap
  }

  return items;
}

export const Pagination = ({
  currentPage,
  totalItems,
  pageSize,
  onPageChange,
  maxButtons = 7,
  className
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const pageItems = getPageItems(currentPage, totalItems, pageSize, maxButtons);

  const goto = (page) => {
    const clamped = Math.min(Math.max(1, page), totalPages);
    if (clamped !== currentPage) onPageChange(clamped);
  };

  const disabledPrev = currentPage <= 1;
  const disabledNext = currentPage >= totalPages;

  return (
    <nav
      className={className ? `pagination ${className}` : "pagination"}
      aria-label="Pagination"
    >
      <ul className="pagination__list" role="list">
        
        <li>
          <button
            className="pagination__btn"
            onClick={() => goto(currentPage - 1)}
            disabled={disabledPrev}
            aria-label="Previous page"
          >
            ‹ Prev
          </button>
        </li>

        {pageItems.map((item, idx) =>
          item === "…" ? (
            <li key={`dots-${idx}`} className="pagination__ellipsis" aria-hidden="true">
              …
            </li>
          ) : (
            <li key={item}>
              <button
                className={`pagination__btn ${
                  item === currentPage ? "is-active" : ""
                }`}
                onClick={() => goto(item)}
                aria-current={item === currentPage ? "page" : undefined}
              >
                {item}
              </button>
            </li>
          )
        )}

        <li>
          <button
            className="pagination__btn"
            onClick={() => goto(currentPage + 1)}
            disabled={disabledNext}
            aria-label="Next page"
          >
            Next ›
          </button>
        </li>
        
      </ul>
      
      <div className="pagination__meta" aria-live="polite">
        Page {currentPage} of {totalPages}
      </div>
    </nav>
  );
};
